/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, {Component} from 'react';
// material
import Area from 'pages/dashboard/reports/detail/area/area';
import Group from 'material/group/group';
import DropFilter from 'material/dropdowns/dropfilter/dropfilter';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/reports/detail/filters/filters_styles';



/* ========== ~~~~~~~~~~ REPORT DETAIL : AREA : FILTERS ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class ReportFilters extends Component {
    constructor(props) {
    	super(props);
	}

	handleSiteInDropDown = () => {
		let sites = [];
		Object.keys(this.props.allSites).forEach( (item) => {
			sites.push({value: item, name: this.props.allSites[item]})
		});
		return sites
	};

	handleCountriesInDropDown = () => {
		let countries = [];
		Object.keys(this.props.allCountries).sort().forEach( (item) => {
			countries.push({value: item, name: this.props.allCountries[item]})
		});
		return countries
	};

	handleDevicesInDropDown = () => {
		let devices = [];
		this.props.allDevices.map(item => {
			return devices.push({ value: item , name: item });
		});
		return devices;
	};

	handleSelectSites = (sites) => {
		this.props.setReportProperties({sites: sites})
	}

	handleSelectDevices = (devices) => {
		this.props.setReportProperties({devices: devices})
	}

	handleSelectCountries = (countries) => {
		this.props.setReportProperties({countries: countries})
	}


	render() {
		return (
			<Area name={`filters`}
				  klass={`${this.props.classes.filters}`}
				  title={`Filters`}
				  tooltip={<p>Use filters if you need to narrow your results. Chosen dimensions will be filtered under
					  this criteria on the report.</p>}>
				<Group name={`filters`} direction={`horizontal`}>
					<DropFilter name={this.props.sites.length === 1 ? 'site' : 'sites'} title={'All Sites'} button={`false`}
								icon={`link`} onSelect={this.handleSelectSites} items={this.handleSiteInDropDown()}
								selectedItems={this.props.sites} disabled={!this.props.sitesReceived}/>
					<DropFilter name={this.props.devices.length === 1 ? 'device' : 'devices'} title={'All Devices'} button={`false`}
								icon={`mobile-alt`} onSelect={this.handleSelectDevices} items={this.handleDevicesInDropDown()}
								selectedItems={this.props.devices}/>
					<DropFilter name={this.props.allCountries.length === 1 ? 'country' : 'countries'}
								title={'All Countries'} icon={`globe`} button={`false`}
								onSelect={this.handleSelectCountries} items={this.handleCountriesInDropDown()}
								selectedItems={this.props.countries}/>
				</Group>
			</Area>
		);
	}
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(ReportFilters);
